<span (dblclick)="editing=true" *ngIf="!editing">{{userc.search_count}}</span>
<div *ngIf="editing">
    <input type="number" class="w-7rem" pInputText [(ngModel)]="userc!.search_count" />
    <p-button icon="pi pi-check" class="h-2rem" (click)="changeSearchCount.emit(userc)" />
</div>
